import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';

const FIELDS = {
    meetingOn: {
        type: "datetime",
        label: "Meeting On",
        isRequired: true,
        xs: 12,
        lg: 12,
        sm: 12,
        md: 12,
        minDate: new Date(),
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        }
    },
    venue: {
        type: "input",
        label: "Venue",
        rows : 4,
        isRequired: true,
        isMultiline:  true,
        xs:12,
        lg:12,
        sm:12,
        md:12,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2, maximum: 255
            }
        }
    },
    contactPerson: {
        type: "input",
        label: "Contact Person",
        isRequired: true,
        xs:12,
        lg:12,
        sm:12,
        md:12,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2, maximum: 50
            },
            format: {
                message: VALIDATION_MESSAGES.INVALID_ONLY_ALPHA_SPACES_ALLOWED,
                pattern: REGEX_PATTERNS.ONLY_ALPHA_SPACES
            }
        }
    }
};

export default FIELDS;